import { render, staticRenderFns } from "./AdoptionReportBookSchool.vue?vue&type=template&id=0142e39b&"
import script from "./AdoptionReportBookSchool.vue?vue&type=script&lang=js&"
export * from "./AdoptionReportBookSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports